import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/analytics"

// Click tracking for elements that have no controller of their own — the
// storefront's WhatsApp CTAs, which are plain links. Attach with:
//
//   data-controller="analytics"
//   data-action="click->analytics#track"
//   data-analytics-name-param="Book WhatsApp"
//   data-analytics-props-param='{"code":12,"title":"Dom Casmurro"}'
//
// The event name travels in the DOM, which sounds loose but isn't: the server
// only stores names listed in app/lib/analytics.rb, so a page (or a tampered
// one) can't invent an event by shipping a different string.
export default class extends Controller {
  track({ params }) {
    if (!params.name) return

    track(params.name, params.props || {})
  }
}
